;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('inboxElement', InboxElement)

  InboxElement.$inject = []

  function InboxElement () {
    return {
      restrict: 'E',
      bindToController: {
        element: '='
      },
      scope: {},
      controllerAs: 'ctrl',
      controller: ['$scope', function ($scope) {
        var self = this
        $scope.$watch(function () {
          return _.get(self, 'element.value')
        }, function () {
          if (!self.element) {
            return
          }
          if (typeof element === 'string') {
            self.type = 'string'
          } else {
            self.type = /function\s?(\w+)\s?\(/.exec(self.element.value.constructor.toString())[1]
          }

          switch (self.type) {
            case 'string':
              self.label = 'Chaîne: ' + self.element.value
              self.color = '#0000ff'
              break
            case 'Entity':
              self.label = 'Client: ' + self.element.value.label
              self.color = '#337ab7'
              break
            case 'Product':
              self.color = '#3c763d'
              self.label = 'Produit: ' + self.element.value.label
              break
          }
        })
      }],
      template: '<span ng-if="ctrl.type" class="label" style="margin:10px;padding:10px;"' +
      'ng-style="{\'background-color\': ctrl.color}"' +
      '>{{ctrl.label}}</span>'
    }
  }
})(window.angular)
